import styled, { css } from 'styled-components'

import { mobileMediaQuery } from '@subaio/webapp'

import { helpers } from 'styles'

export const Container = styled.div`
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 0;
	padding: 1px;
	border: 2px solid ${helpers.color.disabledContrast};
	border-radius: 36px;
	background-color: ${helpers.color.disabledContrast};
	margin: 12px 0 24px;
	max-width: 400px;

	${mobileMediaQuery(css`
		max-width: unset;
	`)}
`
